export default __webpack_public_path__ + "static/media/lottery-btn.defbb0d7.png";